import './../../../../vendor/gsap/TweenMax.js' // quiet

class OverlayItem
{
    constructor (element, show)
    {
        this.initialShow = show

        this.element = element
        this.target = element.getAttribute('data-overlay')
        this.overlay = document.querySelector(this.target)
        this.closeCTA = document.querySelector(`${this.target} .close-drawer`)
        this.backdrop = document.querySelector(`${this.target} .drawer-shadow`)
        this.timeline = null

        this.setup()
        this.addListener()

        if (!document.body.classList.contains("drawer-visible") && this.overlay === this.initialShow) {
            this.open()
        }
    }

    setup () {
        this.timeline = new TimelineLite({force3D: true, paused: true});

        this.timeline.to(`${this.target} .drawer`, 1, {x: 0, skewX: 0, opacity: 1, scale: 1, ease: 'easeInOutQuint'}, "drawerIn")
                .to(`${this.target} .drawer-shadow`, 1, {opacity: 1, x: 0, scale: 1}, "drawerIn")
                .to(`${this.target} .drawer-content`, 1, {opacity: 1, x: 0, scale: 1}, "drawerIn+=0.15");

        this.timeline.timeScale(1);
    }

    addListener () {
        this.element.addEventListener('click', this.onClick.bind(this))
        this.onCloseListener = this.onClose.bind(this)
    }

    onClose (e) {
        e.preventDefault()

        this.closeCTA.removeEventListener('click', this.onCloseListener, false)
        this.backdrop.removeEventListener('click', this.onCloseListener, false)

        document.body.classList.remove("drawer-visible", "no-scroll")
        this.removeHistoryState()
        this.timeline.reverse()
    }

    onClick (e) {
        e.preventDefault()
        this.open()
    }

    open () {
        this.animateIn()
        this.addHistoryState()
        this.scrollPos = window.scrollY
        this.closeCTA.addEventListener('click', this.onCloseListener, false)
        this.backdrop.addEventListener('click', this.onCloseListener, false)
    }

    addHistoryState () {
        let title = this.overlay.getAttribute('data-title')
        let path = this.overlay.getAttribute('data-href')

        window.history.pushState({}, title, path)
    }

    removeHistoryState () {
        let title = document.title
        let from = this.overlay.getAttribute('data-href')
        let path = window.location.pathname.replace(from, '') || '/'

        window.history.pushState({}, title, path)
    }

    animateIn (target) {
        try {
          document.body.querySelector(`${this.target} .drawer-content`).scrollTop = 0
        } catch (err) {
          console.log('[ERROR]', 'Unable to scroll to top')
        }
        document.body.classList.add("drawer-visible")
        document.body.classList.add("no-scroll")
        this.timeline.play()
    }
}

export default OverlayItem
